var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _mask, _path1, _path10, _mask2, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeeMug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.3939 50.8071C74.1116 51.752 73.2384 52.6298 71.5664 53.3121C69.9051 53.9901 67.6058 54.4068 64.794 54.5133C59.1809 54.726 51.7551 53.6948 43.8679 51.3387C35.9806 48.9826 29.206 45.7717 24.6292 42.5151C22.3366 40.8837 20.6426 39.2741 19.6254 37.796C18.6016 36.3084 18.3529 35.0954 18.6352 34.1505C18.9174 33.2057 19.7907 32.3279 21.4627 31.6455C23.124 30.9676 25.4233 30.5508 28.2351 30.4443C33.8482 30.2317 41.274 31.2628 49.1612 33.6189C57.0484 35.975 63.8231 39.1859 68.3998 42.4426C70.6925 44.0739 72.3865 45.6835 73.4037 47.1616C74.4275 48.6493 74.6762 49.8622 74.3939 50.8071Z",
    fill: "#FCFCFC",
    stroke: "#8C74B7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0929 49.4175C70.0084 49.6919 69.6081 50.1441 68.2901 50.4718C67.0418 50.7821 65.2682 50.8987 63.0621 50.7903C58.6656 50.5742 52.7815 49.4776 46.4682 47.5336C40.1549 45.5897 34.673 43.1865 30.9164 40.8921C29.0315 39.7408 27.6307 38.6468 26.7732 37.688C25.8677 36.6757 25.7912 36.0767 25.8757 35.8023C25.9602 35.5279 26.3604 35.0757 27.6784 34.748C28.9267 34.4376 30.7003 34.3211 32.9064 34.4295C37.3029 34.6455 43.1871 35.7422 49.5004 37.6862C55.8137 39.6301 61.2956 42.0333 65.0521 44.3277C66.9371 45.479 68.3379 46.573 69.1954 47.5318C70.1008 48.5441 70.1774 49.1431 70.0929 49.4175Z",
    fill: "#FCFCFC",
    stroke: "#8C74B7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0923 34.1556C-3.80453 81.3456 62.4326 104.9 74.5635 52.0527C61.8959 61.4736 18.5376 46.0045 18.0923 34.1556Z",
    fill: "#FCFCFC",
    stroke: "#8C74B7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.194 78.2377C75.0075 87.5477 85.8403 59.0524 73.843 55.5482C73.3692 57.5131 71.9871 61.216 70.8518 63.3884C73.8735 66.0739 70.8986 72.1246 65.6456 71.5919C62.2537 75.607 59.6166 76.9183 57.194 78.2377Z",
    fill: "#FCFCFC",
    stroke: "#8C74B7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_9",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 33,
    width: 46,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5258 48.8672C69.4705 49.0466 69.1473 49.4546 67.8597 49.7407C66.66 50.0073 64.9484 50.0878 62.8145 49.9542C58.5627 49.6881 52.8607 48.5879 46.7316 46.7006C40.6026 44.8134 35.2693 42.5156 31.6042 40.3441C29.7648 39.2542 28.3949 38.2248 27.5529 37.3296C26.6493 36.3688 26.6115 35.8496 26.6668 35.6701C26.7221 35.4907 27.0453 35.0827 28.3329 34.7966C29.5326 34.53 31.2442 34.4495 33.3782 34.5831C37.6299 34.8492 43.332 35.9494 49.461 37.8367C55.59 39.7239 60.9233 42.0217 64.5884 44.1932C66.4278 45.2831 67.7977 46.3125 68.6397 47.2078C69.5433 48.1685 69.5811 48.6877 69.5258 48.8672Z",
    fill: "#FDFFFF",
    stroke: "#29193E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4315 42.1042C35.4776 41.0943 31.9455 38.8876 24.4861 35.6806L24.8584 47.6482L70.6677 63.7405L73.1087 51.0008C64.6768 46.4218 61.2517 43.1298 46.4315 42.1042Z",
    fill: "#8C74B7",
    stroke: "#8C74B7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8208 71.7482C33.4606 72.559 32.5467 72.8979 31.8033 72.5676C31.0599 72.2372 30.6989 71.3319 31.0591 70.5212C31.1499 70.3167 31.2258 70.2541 31.2475 70.2387C31.2625 70.228 31.2918 70.2093 31.3807 70.2069C31.6286 70.2001 32.0243 70.3189 32.6741 70.6076C33.324 70.8963 33.6773 71.1104 33.8385 71.2989C33.8962 71.3665 33.902 71.4008 33.9041 71.419C33.9072 71.4454 33.9116 71.5438 33.8208 71.7482Z",
    fill: "#8C74B7",
    stroke: "#8C74B7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7704 13.803C44.7704 13.803 52.8313 20.6056 41.7044 27.0784C30.5775 33.5512 39.0455 39.5747 39.0455 39.5747",
    stroke: "#8C74B7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5905 15.8948C63.5905 15.8948 71.6514 22.6974 60.5245 29.1702C49.3976 35.643 57.8657 41.6665 57.8657 41.6665",
    stroke: "#8C74B7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9534 15.2833C53.9534 15.2833 62.0143 22.086 50.8874 28.5587C39.7605 35.0315 48.2286 41.0551 48.2286 41.0551",
    stroke: "#8C74B7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1901 57.1778C29.956 59.5192 29.0548 61.5282 27.836 62.8892C26.6167 64.2508 25.1373 64.9135 23.6852 64.7654C22.2331 64.6173 20.9148 63.6692 19.9897 62.0888C19.0649 60.5091 18.5797 58.3587 18.8139 56.0173C19.048 53.6759 19.9491 51.6668 21.1679 50.3058C22.3873 48.9442 23.8667 48.2815 25.3188 48.4296C26.7708 48.5778 28.0892 49.5258 29.0143 51.1062C29.939 52.6859 30.4242 54.8363 30.1901 57.1778Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_24_9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6565 57.8266C22.7095 59.2023 23.1255 60.4465 23.8206 61.3086C24.5157 62.1708 25.4385 62.587 26.4032 62.4735C27.368 62.3601 28.303 61.7253 29.0203 60.697C29.7376 59.6688 30.1839 58.3232 30.2694 56.9312C30.3548 55.5392 30.0731 54.2039 29.481 53.1941C28.8888 52.1844 28.0301 51.575 27.0776 51.4886C26.1252 51.4022 25.1497 51.8452 24.3474 52.7285C23.545 53.6119 22.9755 54.8699 22.7533 56.2495L26.4675 56.9849L22.6565 57.8266Z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6565 57.8266C22.7095 59.2023 23.1255 60.4465 23.8206 61.3086C24.5157 62.1708 25.4385 62.587 26.4032 62.4735C27.368 62.3601 28.303 61.7253 29.0203 60.697C29.7376 59.6688 30.1839 58.3232 30.2694 56.9312C30.3548 55.5392 30.0731 54.2039 29.481 53.1941C28.8888 52.1844 28.0301 51.575 27.0776 51.4886C26.1252 51.4022 25.1497 51.8452 24.3474 52.7285C23.545 53.6119 22.9755 54.8699 22.7533 56.2495L26.4675 56.9849L22.6565 57.8266Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-12-inside-1_24_9)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8006 64.1077C49.5665 66.4491 48.6654 68.4581 47.4466 69.8191C46.2272 71.1808 44.7478 71.8435 43.2958 71.6953C41.8437 71.5472 40.5253 70.5991 39.6002 69.0187C38.6755 67.4391 38.1903 65.2886 38.4244 62.9472C38.6585 60.6058 39.5597 58.5968 40.7785 57.2358C41.9978 55.8741 43.4772 55.2114 44.9293 55.3596C46.3814 55.5077 47.6997 56.4558 48.6248 58.0362C49.5496 59.6158 50.0348 61.7663 49.8006 64.1077Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-2_24_9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2669 64.7565C42.32 66.1323 42.7359 67.3764 43.4311 68.2385C44.1262 69.1007 45.049 69.5169 46.0137 69.4035C46.9784 69.29 47.9135 68.6553 48.6308 67.627C49.3481 66.5987 49.7944 65.2532 49.8798 63.8611C49.9653 62.4691 49.6836 61.1339 49.0914 60.1241C48.4993 59.1143 47.6406 58.5049 46.6881 58.4185C45.7357 58.3321 44.7601 58.7752 43.9578 59.6585C43.1555 60.5418 42.586 61.7998 42.3638 63.1795L46.078 63.9148L42.2669 64.7565Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2669 64.7565C42.32 66.1323 42.7359 67.3764 43.4311 68.2385C44.1262 69.1007 45.049 69.5169 46.0137 69.4035C46.9784 69.29 47.9135 68.6553 48.6308 67.627C49.3481 66.5987 49.7944 65.2532 49.8798 63.8611C49.9653 62.4691 49.6836 61.1339 49.0914 60.1241C48.4993 59.1143 47.6406 58.5049 46.6881 58.4185C45.7357 58.3321 44.7601 58.7752 43.9578 59.6585C43.1555 60.5418 42.586 61.7998 42.3638 63.1795L46.078 63.9148L42.2669 64.7565Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-14-inside-2_24_9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeMug);
export default __webpack_public_path__ + "static/media/CoffeeMug.a27daa206392ef26c03a9760b1998576.svg";
export { ForwardRef as ReactComponent };